<template>

  <svg
    t="1632727355023"
    class="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="5722"
    width="64"
    height="64"
  ><path d="M897.77857168 512q0 104.97857167-51.75 193.62857168t-140.4 140.4-193.62857168 51.75-193.62857168-51.75-140.4-140.4-51.74999999-193.62857168 51.75-193.62857168 140.39999999-140.4 193.62857168-51.75 193.62857168 51.75 140.4 140.4 51.75 193.62857168z" p-id="5723" /></svg>


</template>

<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'JtIconShapeCircle',
} as DefineComponent
</script>